module.exports = __webpack_public_path__ + "static/media/year-built-lazy.58b854e5.jpg";